import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNotice, getNoticeDetail } from "./../../../pages/Notification/redux/actions"

export const useNotice = (params) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { notices, isProcessing, lastPage, currentPage, total } = useSelector(state => state.noticeReducers);
  useEffect(() => {
    if (!location?.state?.type || location?.state?.type != 'notLoadPage') {
      dispatch(getNotice(params));
    }
  }, [params, getNotice, dispatch]);

  return [notices, isProcessing, lastPage, currentPage, total]
};

export const useNoticeDetail = (id) => {
  const dispatch = useDispatch();
  const { item, isProcessingItem } = useSelector(state => state.noticeReducers);

  useEffect(() => {
    if (id) {
      dispatch(getNoticeDetail({id}));
    }
  }, [id, dispatch, getNoticeDetail]);

  return [item, isProcessingItem]
};


